import { FC } from 'react';

import { Box, Stack } from '@mui/material';
import { IDictionaryItem } from 'api/types';
import { useAppSelector } from 'hooks';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';

import { checkChosenOptionsFilter } from '../../utils/filters';
import FiltersContainer from './FiltersContainer';
import { CollegeFilter, IndustryFilter, SpecialityFilter } from './specificFilters';

interface IRecommendationOpenDayFiltersProps {
  industryOptions: IDictionaryItem[];
  specialityOptions: IDictionaryItem[];
  collegeOptions: IDictionaryItem[];
}

const RecommendationOpenDayFilters: FC<IRecommendationOpenDayFiltersProps> = ({
  industryOptions,
  specialityOptions,
  collegeOptions,
}) => {
  const filters = useAppSelector((state) => state.proforientationRecommendationFilters);

  const industryControl = <IndustryFilter section="dods" options={industryOptions} />;
  const specialityControl = <SpecialityFilter section="dods" options={specialityOptions} />;
  const collegeControl = <CollegeFilter section="dods" options={collegeOptions} />;

  const handleFiltersApply = () => {
    const chosenIndustries = industryOptions
      .filter((industry) => checkChosenOptionsFilter(industry.code, filters['dods/industry']))
      .map((item) => item.value);
    const chosenSpecialities = specialityOptions
      .filter((speciality) => checkChosenOptionsFilter(speciality.code, filters['dods/speciality']))
      .map((item) => item.value);
    const chosenColleges = collegeOptions
      .filter((college) => checkChosenOptionsFilter(college.code, filters['dods/college']))
      .map((item) => item.value);

    emitYMEvent({
      type: 'openDay_startSearching_click',
      payload: {
        industry: chosenIndustries.toString(),
        speciality: chosenSpecialities.toString(),
        college: chosenColleges.toString(),
      },
    });
  };

  const handleFiltersClick = () => {
    emitYMEvent({ type: 'openDay_filters_click' });
  };

  const handleFiltersReset = () => {
    emitYMEvent({ type: 'openDay_resetAll_click' });
  };

  return (
    <FiltersContainer
      sectionKey="dods"
      controlKeys={['industry', 'speciality', 'college']}
      onFiltersClick={handleFiltersClick}
      onFiltersReset={handleFiltersReset}
      onFiltersApply={handleFiltersApply}
    >
      <Stack gap="12px">
        <Box className="row" sx={{ display: 'flex', gap: '12px' }}>
          {industryControl}
          {specialityControl}
        </Box>
        {collegeControl}
      </Stack>
    </FiltersContainer>
  );
};

export default RecommendationOpenDayFilters;
